import { useState, useEffect } from 'react';
import { Eye, Download } from 'lucide-react';
import { getAdminEmployerRequirements, downloadResume } from '../../services/api';

export default function AdminRequirements() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    getAdminEmployerRequirements().then(res => { setItems(res.data); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  if (loading) return <div className="loading"><div className="spinner"></div></div>;

  return (
    <>
      <div className="admin-table-wrap">
        <div className="admin-table-header">
          <h2>Employer Requirements ({items.length})</h2>
        </div>
        {items.length === 0 ? (
          <div className="empty-state"><h3>No requirements submitted yet</h3><p>Employer requirements will appear here</p></div>
        ) : (
          <table className="admin-table">
            <thead><tr><th>Name</th><th>Company</th><th>Enquiry For</th><th>Email</th><th>Phone</th><th>City</th><th>Date</th><th>Actions</th></tr></thead>
            <tbody>
              {items.map(item => (
                <tr key={item.id}>
                  <td style={{ fontWeight: 600 }}>{item.name}</td>
                  <td>{item.companyName}</td>
                  <td><span className="status-badge status-published" style={{ fontSize: '0.7rem' }}>{item.enquiryFor}</span></td>
                  <td>{item.email}</td>
                  <td>{item.phone}</td>
                  <td>{item.city || item.currentCity}</td>
                  <td>{new Date(item.createdAt).toLocaleDateString()}</td>
                  <td>
                    <div className="table-actions">
                      <button className="btn-edit" onClick={() => setSelected(item)}><Eye size={14} /> View</button>
                      {item.documentPath && (
                        <a href={downloadResume(item.documentPath)} target="_blank" rel="noreferrer">
                          <button className="btn-download"><Download size={14} /> Doc</button>
                        </a>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {selected && (
        <div className="modal-overlay" onClick={() => setSelected(null)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <h2>Requirement Details</h2>
            <div style={{ display: 'grid', gap: 16 }}>
              <div><strong>Enquiry For:</strong> {selected.enquiryFor}</div>
              <div><strong>Name:</strong> {selected.name}</div>
              <div><strong>Company:</strong> {selected.companyName}</div>
              <div><strong>Country:</strong> {selected.country}</div>
              <div><strong>Current City:</strong> {selected.currentCity}</div>
              {selected.currentLocality && <div><strong>Locality:</strong> {selected.currentLocality}</div>}
              <div><strong>City:</strong> {selected.city}</div>
              <div><strong>Email:</strong> {selected.email}</div>
              <div><strong>Phone:</strong> {selected.phone}</div>
              <div><strong>Date:</strong> {new Date(selected.createdAt).toLocaleString()}</div>
              <div>
                <strong>Requirement:</strong>
                <p style={{ marginTop: 8, color: '#475569', lineHeight: 1.7, background: '#f8fafc', padding: 16, borderRadius: 8 }}>
                  {selected.requirement}
                </p>
              </div>
              {selected.documentPath && (
                <div>
                  <strong>Document:</strong>{' '}
                  <a href={downloadResume(selected.documentPath)} target="_blank" rel="noreferrer" style={{ color: '#2563eb', fontWeight: 600 }}>
                    Download {selected.documentOriginalName}
                  </a>
                </div>
              )}
            </div>
            <div className="modal-actions">
              <button className="btn-cancel" onClick={() => setSelected(null)}>Close</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
